(function () {
    "use strict";

    angular.module('iMatApp')
        .controller('ShareLinkController', ShareLinkController);

    ShareLinkController.$inject = ['$scope', '$timeout', '$log', 'urlService', 'eventService', 'uploadModelConsts', 'googleTagManagerService'];

    function ShareLinkController($scope, $timeout, $log, urlService, eventService, consts, googleTagManagerService) {
        var vm = this;
        var hideTimer = null;

        vm.linkToCopy = null;
        vm.isSuccessCopied = false;
        vm.isCopyFailed = false;
        vm.processing = false;

        vm.onSuccess = onSuccess;
        vm.onError = onError;

        $scope.$on("$destroy", resetTimer);
        eventService.subscribe($scope, consts.eventNames.menuItemOpened, menuItemOpened);

        // ----------------------------------- Public functions -----------------------------

        function menuItemOpened(menuItemName) {
            if (menuItemName === 'ShareModel') {
                refreshLinkToCopy();
                trackShareModelTabEvent();
            }
        }

        function refreshLinkToCopy() {
            vm.processing = true;

            var currentUrl = urlService.getCurrentAbsoluteUrl();
            urlService.shorten(currentUrl)
                .then(function (newLink) {
                    vm.linkToCopy = newLink;
                })
                .catch(function() {
                    vm.linkToCopy = currentUrl;
                })
                .finally(function () {
                    vm.processing = false;
                });
        }

        function onSuccess(e) {
            vm.isSuccessCopied = true;
            vm.isCopyFailed = false;
            trackShareModelEvent('Status: Succeed');
            hideNotificationsDelay(2000);
        }

        function onError(e) {
            vm.isSuccessCopied = false;
            vm.isCopyFailed = true;
            trackShareModelEvent('Status: Failed');
            hideNotificationsDelay(5000);
        }               

        // ----------------------------------- Private functions -----------------------------

        function hideNotificationsDelay(hideAfterMs) {
            resetTimer();

            hideTimer = $timeout(function () {
                vm.isSuccessCopied = false;
                vm.isCopyFailed = false;
                resetTimer();
            }, hideAfterMs);
        }

        function resetTimer() {
            if (hideTimer) {
                $timeout.cancel(hideTimer);
                hideTimer = null;
            }
        }

        function trackShareModelTabEvent() {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Share Model',
                'eventAction': 'Single Upload Page - Open Tab in Menu',
                'eventLabel': undefined,
                'eventValue': undefined
            });
        }

        function trackShareModelEvent(eventStatus) {
            googleTagManagerService.pushToDataLayer({
                'event': 'imat.event',
                'eventCategory': '[Interaction - Tracking] Share Model',
                'eventAction': 'Single Upload Page - Copy Link Button',
                'eventLabel': eventStatus,
                'eventValue': undefined
            });
        }
    }
})();